import { __decorate, __param } from 'tslib';
import { Inject, ElementRef, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import { typedFromEvent, TUI_DEFAULT_IDENTITY_MATCHER, isPresent } from '@taiga-ui/cdk';
import { TUI_DATA_LIST_HOST, TuiOptionComponent, TuiSvgModule, TuiScrollIntoViewModule } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT, PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { merge, EMPTY } from 'rxjs';
import { startWith, map, distinctUntilChanged } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core';
import * as ɵngcc3 from '@angular/forms';

function TuiSelectOptionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiSelectOptionComponent_tui_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 3);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("tuiScrollIntoView", true);
} }
function TuiSelectOptionComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 4);
} }
let TuiSelectOptionComponent = class TuiSelectOptionComponent {
    constructor(context, host, elementRef, option, control) {
        var _a;
        this.context = context;
        this.host = host;
        this.elementRef = elementRef;
        this.option = option;
        this.control = control;
        this.selected$ = merge((_a = this.control.valueChanges) !== null && _a !== void 0 ? _a : EMPTY, typedFromEvent(this.elementRef.nativeElement, 'animationstart')).pipe(startWith(null), map(() => this.selected), distinctUntilChanged());
    }
    get matcher() {
        return this.host.identityMatcher || TUI_DEFAULT_IDENTITY_MATCHER;
    }
    ngOnInit() {
        if (isPresent(this.option.value) && this.host.checkOption) {
            this.host.checkOption(this.option.value);
        }
    }
    get selected() {
        return (isPresent(this.option.value) &&
            isPresent(this.control.value) &&
            this.matcher(this.control.value, this.option.value));
    }
};
TuiSelectOptionComponent.ɵfac = function TuiSelectOptionComponent_Factory(t) { return new (t || TuiSelectOptionComponent)(ɵngcc0.ɵɵdirectiveInject(POLYMORPHEUS_CONTEXT), ɵngcc0.ɵɵdirectiveInject(TUI_DATA_LIST_HOST), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TuiOptionComponent), ɵngcc0.ɵɵdirectiveInject(NgControl)); };
TuiSelectOptionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiSelectOptionComponent, selectors: [["tui-select-option"]], decls: 5, vars: 5, consts: [[4, "ngTemplateOutlet"], ["automation-id", "tui-select-option__checkmark", "src", "tuiIconCheckLarge", "class", "checkmark", 3, "tuiScrollIntoView", 4, "ngIf", "ngIfElse"], ["dummy", ""], ["automation-id", "tui-select-option__checkmark", "src", "tuiIconCheckLarge", 1, "checkmark", 3, "tuiScrollIntoView"], [1, "dummy"]], template: function TuiSelectOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiSelectOptionComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, TuiSelectOptionComponent_tui_svg_1_Template, 1, 1, "tui-svg", 1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵtemplate(3, TuiSelectOptionComponent_ng_template_3_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.context.$implicit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 3, ctx.selected$))("ngIfElse", _r2);
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, ɵngcc2.TuiSvgComponent, ɵngcc2.TuiScrollIntoViewDirective], pipes: [ɵngcc1.AsyncPipe], styles: ["@-webkit-keyframes retrigger{from{left:1px}to{left:2px}}@keyframes retrigger{from{left:1px}to{left:2px}}[_nghost-%COMP%]{display:flex;flex:1;align-items:center;max-width:100%;-webkit-animation:1s retrigger;animation:1s retrigger}.checkmark[_ngcontent-%COMP%]{margin:0 -.375rem 0 auto;border-left:5px solid transparent}.dummy[_ngcontent-%COMP%]{width:1.5rem}"], changeDetection: 0 });
TuiSelectOptionComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [POLYMORPHEUS_CONTEXT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_DATA_LIST_HOST,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: TuiOptionComponent, decorators: [{ type: Inject, args: [TuiOptionComponent,] }] },
    { type: NgControl, decorators: [{ type: Inject, args: [NgControl,] }] }
];
TuiSelectOptionComponent = __decorate([ __param(0, Inject(POLYMORPHEUS_CONTEXT)),
    __param(1, Inject(TUI_DATA_LIST_HOST)),
    __param(2, Inject(ElementRef)),
    __param(3, Inject(TuiOptionComponent)),
    __param(4, Inject(NgControl))
], TuiSelectOptionComponent);
const TUI_SELECT_OPTION = new PolymorpheusComponent(TuiSelectOptionComponent);

let TuiSelectOptionModule = class TuiSelectOptionModule {
};
TuiSelectOptionModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiSelectOptionModule });
TuiSelectOptionModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiSelectOptionModule_Factory(t) { return new (t || TuiSelectOptionModule)(); }, imports: [[CommonModule, TuiSvgModule, TuiScrollIntoViewModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiSelectOptionComponent, [{
        type: Component,
        args: [{
                selector: 'tui-select-option',
                template: "<ng-container *ngTemplateOutlet=\"context.$implicit\"></ng-container>\n<tui-svg\n    *ngIf=\"selected$ | async; else dummy\"\n    automation-id=\"tui-select-option__checkmark\"\n    src=\"tuiIconCheckLarge\"\n    class=\"checkmark\"\n    [tuiScrollIntoView]=\"true\"\n></tui-svg>\n<ng-template #dummy>\n    <span class=\"dummy\"></span>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: ["@-webkit-keyframes retrigger{from{left:1px}to{left:2px}}@keyframes retrigger{from{left:1px}to{left:2px}}:host{display:flex;flex:1;align-items:center;max-width:100%;-webkit-animation:1s retrigger;animation:1s retrigger}.checkmark{margin:0 -.375rem 0 auto;border-left:5px solid transparent}.dummy{width:1.5rem}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [POLYMORPHEUS_CONTEXT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_DATA_LIST_HOST]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc2.TuiOptionComponent, decorators: [{
                type: Inject,
                args: [TuiOptionComponent]
            }] }, { type: ɵngcc3.NgControl, decorators: [{
                type: Inject,
                args: [NgControl]
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiSelectOptionModule, { declarations: function () { return [TuiSelectOptionComponent]; }, imports: function () { return [CommonModule, TuiSvgModule, TuiScrollIntoViewModule]; }, exports: function () { return [TuiSelectOptionComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiSelectOptionModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TuiSvgModule, TuiScrollIntoViewModule],
                declarations: [TuiSelectOptionComponent],
                exports: [TuiSelectOptionComponent],
                entryComponents: [TuiSelectOptionComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_SELECT_OPTION, TuiSelectOptionComponent, TuiSelectOptionModule };

//# sourceMappingURL=taiga-ui-kit-components-select-option.js.map